/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit Content.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import * as fromData from 'Data/ViewsData.js'
import Info from 'DesignSystem/Info/view.js'
import InputSmallLabel from 'DesignSystem/InputSmallLabel/view.js'
import React from 'react'
import useIsMedia from 'Logic/useIsMedia.js'



export default function Content({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  isInvalid,
onChange,
onSubmit,
value,
viewPath= "/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Change/Dependents/Email/Content"
}) {
    
    
    let isMedia = useIsMedia()
    
    let data = fromData.useData({ viewPath, path: 'related_member.user.email', 
context: 'related_member',
validate: 'email',
validateRequired: true,
})
    

  return (<React.Fragment
>
<InputSmallLabel
 data-testid="Content.InputSmallLabel"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Change/Dependents/Email/Content"
viewPath={`${viewPath}/InputSmallLabel`}
 isInvalid={data.isInvalid}
 label="Email"
 onChange={data.onChange}
 onSubmit={data.onSubmit}
 placeholder="name@email.com"
 type="email"
 marginTop={16}
 value={data.value}
 width={isMedia.mobile ? "100%" : "400px"}
 color="#161616"
/>
<Info
 data-testid="Content.Info"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Change/Dependents/Email/Content"
viewPath={`${viewPath}/Info`}
 marginTop={8}
 maxWidth={600}
 overflowX="visible"
 text="This person can access my account. By granting access, I acknowledge that this person will have the ability to update personal information and primary care assignments for all members covered under my plan."
 whiteSpace="wrap"
/>
{children}
</React.Fragment>)
}